
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorBase } from '@/components/a-interfaz/a-controlador';
    import conexion from './conexion.vue';
    import usuario from './usuario.vue';
    import notificaciones from './notificaciones.vue';

    @Component( {
        name: "Componente",
        props: {},
        components: {
            conexion,
            usuario,
            notificaciones,
        }
    } )
    export default class Componente extends Vue
    {
        @Prop() public Controlador: ControladorBase;
        @Prop( { default: false } ) public Movil: boolean;
        @Prop( { default: false } ) public SinAtras: boolean;
        @Prop( { default: true } ) public MostrarTitulo: boolean;
        @Prop( { default: false } ) public SinChat: boolean;
        @Prop( { default: false } ) public BotonMenu: boolean;
        @Prop( { default: false } ) public SinOpcionesIzquierda: boolean;
        @Prop( { default: false } ) public SinOpcionesDerecha: boolean;
        @Prop( { default: false } ) public SinRed: boolean;
        @Prop( { default: false } ) public SinNotificaciones: boolean;
        @Prop( { default: false } ) public SinUsuario: boolean;



    }
